var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "56ki1fyf6a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 489",
    transform: "translate(0 .01)",
    style: {
      fill: "none"
    },
    d: "M0 0h13v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 182"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 181",
    transform: "translate(0 -.01)",
    style: {
      clipPath: "url(#56ki1fyf6a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 259",
    d: "M0 37.067V19.983h2.429v1.219h-1.2v14.647h5.466v1.212z",
    transform: "translate(0 -19.056)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 260",
    d: "M164.947 37.079V35.858h5.463V21.214h-1.193V20h2.428v17.079z",
    transform: "translate(-158.252 -19.069)",
    style: {
      fill: "#24ae5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 261",
    d: "M31.531 50.019v1.211H35.8v1.22c-1.346 0-2.691.005-4.037 0-.181 0-.225.05-.225.228q.008 5.254 0 10.509c0 .177.044.229.225.228 1.346-.007 2.691 0 4.037 0V64.675h-5.466V50.019z",
    transform: "translate(-29.102 -47.873)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 262",
    d: "M164.94 64.648v-1.251h4.244V52.442h-4.244v-1.214h4.27v-1.223h1.19v14.643z",
    transform: "translate(-158.247 -47.86)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 263",
    d: "M64.167 120.857c-1.346 0-2.692-.005-4.037 0-.181 0-.225-.05-.225-.228q.008-5.255 0-10.509c0-.177.044-.229.225-.228 1.346.007 2.691 0 4.037 0v1.215h-.464c-.1 0-.148.027-.147.136q.007.474 0 .947c0 .109.048.139.147.136h.464v1.217h-.464c-.1 0-.148.027-.147.136q.007.474 0 .947c0 .109.048.139.147.136h.464v1.217h-.464c-.1 0-.148.027-.147.136q.007.474 0 .947c0 .109.048.139.147.136h.464v1.217h-.464c-.1 0-.148.027-.147.136q.007.474 0 .947c0 .109.048.139.147.136h.464v1.215zm-1.824-4.243v-.486c0-.1-.032-.146-.14-.144-.317 0-.634 0-.951.008a.181.181 0 0 0-.122.127q-.016.475 0 .951a.181.181 0 0 0 .122.127c.317.011.634 0 .951.008.108 0 .142-.043.139-.145v-.445m.014 2.424h-.014v-.465c0-.113-.037-.155-.152-.153-.3.005-.607 0-.911 0-.108 0-.161.026-.159.146.006.31 0 .621 0 .931 0 .1.035.146.141.143.162-.005.324 0 .486 0 .187 0 .452.057.541-.04s.05-.366.065-.559m-.635-6.69v-.015c.148 0 .3-.006.445 0 .128.007.182-.032.178-.169-.009-.3-.007-.594 0-.89 0-.125-.042-.164-.164-.162-.3.006-.594.008-.89 0-.141 0-.173.055-.167.18.008.148 0 .3 0 .445 0 .187-.059.451.038.542s.365.052.557.068m-.005 2.42h.486c.1 0 .143-.037.142-.142v-.931c0-.1-.027-.149-.137-.147-.317 0-.634 0-.951.007a.181.181 0 0 0-.125.125c-.011.317 0 .634-.007.951 0 .11.048.14.147.137h.445",
    transform: "translate(-57.474 -105.319)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 264",
    d: "M165.005 113.707v-1.217h2.834c.172 0 .22-.052.212-.218a7.986 7.986 0 0 1 0-.789c.008-.166-.04-.219-.212-.218-.945.008-1.889 0-2.834 0v-1.215h4.244v10.951h-4.244v-1.215h2.834c.172 0 .22-.052.212-.218a7.986 7.986 0 0 1 0-.789c.008-.166-.04-.219-.212-.218-.945.008-1.889 0-2.834 0v-1.201h2.834c.172 0 .22-.052.212-.218a7.986 7.986 0 0 1 0-.789c.008-.166-.04-.219-.212-.218-.945.008-1.889 0-2.834 0v-1.217h2.834c.172 0 .22-.052.212-.218a7.986 7.986 0 0 1 0-.789c.008-.166-.04-.219-.212-.218-.945.008-1.889 0-2.834 0z",
    transform: "translate(-158.31 -105.476)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 265",
    d: "M91.168 260.6v.445c0 .1-.031.146-.139.145-.317 0-.634 0-.951-.008a.181.181 0 0 1-.122-.127q-.016-.475 0-.951a.181.181 0 0 1 .122-.127c.317-.011.634 0 .951-.008.107 0 .143.042.14.144v.486",
    transform: "translate(-86.299 -249.301)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 266",
    d: "M91.187 320.575c-.015.192.038.447-.065.559s-.354.036-.541.04h-.486c-.106 0-.143-.039-.141-.143 0-.31.005-.621 0-.931 0-.12.051-.148.159-.146.3 0 .607.005.911 0 .115 0 .156.04.152.153-.006.155 0 .31 0 .465h.014",
    transform: "translate(-86.304 -306.856)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 267",
    d: "M90.223 141.165c-.192-.016-.447.036-.557-.068s-.034-.355-.038-.542c0-.148.005-.3 0-.445-.007-.125.026-.184.167-.18.3.009.594.007.89 0 .122 0 .167.037.164.162-.007.3-.008.594 0 .89 0 .137-.049.177-.178.169-.148-.008-.3 0-.445 0v.015",
    transform: "translate(-85.975 -134.136)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 268",
    d: "M90.558 201.186h-.445c-.1 0-.149-.027-.147-.137 0-.317 0-.634.007-.951a.181.181 0 0 1 .125-.125c.317-.011.634 0 .951-.007.11 0 .138.048.137.147v.931c0 .1-.037.145-.142.142-.162-.005-.324 0-.486 0",
    transform: "translate(-86.316 -191.737)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 269",
    d: "M150.577 261.189h-.464c-.1 0-.148-.027-.147-.136q.007-.474 0-.947c0-.109.048-.139.147-.136h.464v1.218",
    transform: "translate(-143.882 -249.306)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 270",
    d: "M150.577 201.189h-.464c-.1 0-.148-.027-.147-.136q.007-.474 0-.947c0-.109.048-.139.147-.136h.464v1.218z",
    transform: "translate(-143.882 -191.74)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 271",
    d: "M150.577 141.189h-.464c-.1 0-.148-.027-.147-.136q.007-.474 0-.947c0-.109.048-.139.147-.136h.464v1.218z",
    transform: "translate(-143.882 -134.175)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 272",
    d: "M150.577 321.189h-.464c-.1 0-.148-.027-.147-.136q.007-.474 0-.947c0-.109.048-.139.147-.136h.464v1.218z",
    transform: "translate(-143.882 -306.871)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 273",
    d: "M165.005 261.126v-1.218h2.834c.172 0 .22.052.212.218a7.986 7.986 0 0 0 0 .789c.008.166-.04.219-.212.218-.945-.008-1.889 0-2.834 0",
    transform: "translate(-158.31 -249.242)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 274",
    d: "M165.005 321.126v-1.218h2.834c.172 0 .22.052.212.218a7.986 7.986 0 0 0 0 .789c.008.166-.04.219-.212.218-.945-.008-1.889 0-2.834 0",
    transform: "translate(-158.31 -306.808)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 275",
    d: "M165.005 141.126v-1.218h2.834c.172 0 .22.052.212.218a7.986 7.986 0 0 0 0 .789c.008.166-.04.219-.212.218-.945-.008-1.889 0-2.834 0",
    transform: "translate(-158.31 -134.111)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 276",
    d: "M165.005 201.126v-1.218h2.834c.172 0 .22.052.212.218a7.986 7.986 0 0 0 0 .789c.008.166-.04.219-.212.218-.945-.008-1.889 0-2.834 0",
    transform: "translate(-158.31 -191.677)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 488",
    transform: "translate(2 .01)",
    style: {
      fill: "#0d90db"
    },
    d: "M0 0h9v4H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.7a0cb0afbe1b77af9f5adc8a23d1e565.svg";
export { ForwardRef as ReactComponent };